/**
 * Reads a single field's error state out of the business error record the validation engine
 * produces (`{ [field]: { hasError, errorMessage } }`). Shared by the business field groups so the
 * `hasError` / `errorMessage` extraction isn't repeated per input.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFieldError = (errors: any, field: string): { hasError: boolean; errorMessage: string } => ({
    hasError: Boolean(errors?.[field]?.hasError),
    errorMessage: (errors?.[field]?.errorMessage ?? '') as string
});
